import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CustomCTA = () => {
  const navigate = useNavigate();
  return (
    <section className="w-full py-16 px-6 bg-transparent">
      <div className="max-w-[1100px] mx-auto relative">
        
        {/* Éléments de design pointillés (SVG pour plus de contrôle) */}
        <div className="absolute -top-10 -left-10 w-40 h-40 opacity-20 hidden md:block">
          <svg width="100%" height="100%" viewBox="0 0 100 100">
            <rect x="0" y="0" width="100" height="100" fill="none" stroke="#3b82f6" strokeWidth="1" strokeDasharray="4 4" />
          </svg>
        </div>
        <div className="absolute -bottom-10 -right-10 w-40 h-40 opacity-20 hidden md:block">
          <svg width="100%" height="100%" viewBox="0 0 100 100">
            <rect x="0" y="0" width="100" height="100" fill="none" stroke="#3b82f6" strokeWidth="1" strokeDasharray="4 4" />
          </svg>
        </div>

        {/* Carte Principale */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden bg-gradient-to-br from-[#1e3a5f] to-[#0f172a] rounded-[2rem] p-10 md:p-16 text-center shadow-2xl shadow-blue-900/20 border border-white/5"
        >
          {/* Effet de brillance discret */}
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_0%,rgba(59,130,246,0.15),transparent_70%)] pointer-events-none" />

          <div className="relative z-10 max-w-2xl mx-auto">
            <h2 className="text-white text-3xl md:text-4xl font-black mb-6 tracking-tight">
              Besoin d'un accompagnement personnalisé ?
            </h2>
            
            <p className="text-blue-100/70 text-lg font-medium mb-10 leading-relaxed">
              Nos experts sont là pour vous aider à mettre en œuvre les stratégies présentées dans ces ressources.
            </p>

            <motion.button 
              onClick={() => navigate('/rdv')}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              className="bg-white text-[#1e3a5f] px-10 py-4 rounded-xl font-bold text-base shadow-lg hover:shadow-white/10 hover:bg-blue-50 transition-all flex items-center justify-center gap-3 mx-auto group"
            >
              Découvrez nos services
              
            </motion.button>
          </div>

          {/* Bordure intérieure décorative (optionnelle, pour le look de l'image) */}
          <div className="absolute inset-4 border border-white/5 rounded-[1.5rem] pointer-events-none" />
        </motion.div>
      </div>
    </section>
  );
};

export default CustomCTA;